<template>
  <div class="_make-article ">
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การดึงข้อมูลโดยใช้ onechat_token</h1>
    </header>
<div class="hidden-sm-and-down">
<p>รูปแบบ url เมื่อเลือก <i class="fas fa-check"></i> ต้องการข้อมูลผู้ใช้งาน แบบ onechat_token</p>
        <p>
          <span class="codeExampleUrl">url?onechat_token=0nIhJjZxI2YMxxx&expired_date=1587664633516</span>
        </p>
        <p>
          ผู้ใช้สามารถนำค่าของonechat_token ไปดึงข้อมูลของ user ที่ทำการเปิดเว็บไซต์ได้ จาก
        </p>
        <p>
          <header class="EndpointHeader">
        <span class="EndpointUrl">{{url}}</span>
        <span class="EndpointVerbPost">POST</span>
    </header>


        </p>
        <div>
          <strong>Request Header</strong>
          <br>
          <code class="codecolor" style="">
            <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
          </code>
        </div>

    <br>
        <div>
          <strong>Request Body (json)</strong>
          <br>
          <code class="codecolor" style="">
    {
      <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B12345xxxx"</span>,
      <span class="colorkey">"source"</span> : <span class="colorvalue">"0nIhJjZxI2YMxxx"</span>
    }
          </code>
        </div>
        <br>
        <div>
          <strong>ข้อมูลที่ได้ (Response)</strong>
          <br>
          <code class="codecolor" style="">
    {
      <span class="colorkey">"data"</span> : {
        <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
        <span class="colorkey">"nickname"</span> : <span class="colorvalue">"น้องonechat"</span>,
        <span class="colorkey">"one_id"</span> : <span class="colorvalue">"1234567"</span>,
        <span class="colorkey">"profilepicture"</span> : <span class="colorvalue">"https://onechat.th/pic/xhfsx"</span>
      },
      <span class="colorkey">"status"</span> : <span class="colorvalue">"Success"</span>
    }
          </code>
        </div>
</div>

<div class="hidden-md-and-up">
<p>รูปแบบ url เมื่อเลือก <i class="fas fa-check"></i> ต้องการ profile</p>
        <p>
          <span class="codeExampleUrl">url?onechat_token=0nIhJjZxI2YMxxx&expired_date=1587664633516</span>
        </p>
        <p>
          ผู้ใช้สามารถนำค่าของonechat_token ไปดึงข้อมูลของ user ที่ทำการเปิดเว็บไซต์ได้ จาก
        </p>
        <p>
          <span class="EndpointUrl">{{url}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="EndpointVerbPost">POST</span>
        </p>
        <div>
          <strong>Request Header</strong>
          <br>
          <code class="codecolormo" style="">
            <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
          </code>
        </div>

    <br>
        <div>
          <strong>Request Body (json)</strong>
          <br>
          <code class="codecolormo" style="">
    {
      <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B12345xxxx"</span>,
      <span class="colorkey">"source"</span> : <span class="colorvalue">"0nIhJjZxI2YMxxx"</span>
    }
          </code>
        </div>
        <br>
        <div>
          <strong>ข้อมูลที่ได้ (Response)</strong>
          <br>
          <code class="codecolormo" style="">
    {
      <span class="colorkey">"data"</span> : {
        <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
        <span class="colorkey">"nickname"</span> : <span class="colorvalue">"น้องonechat"</span>,
        <span class="colorkey">"one_id"</span> : <span class="colorvalue">"1234567"</span>,
        <span class="colorkey">"profilepicture"</span> : <span class="colorvalue">"https://onechat.th/pic/xhfsx"</span>
      },
      <span class="colorkey">"status"</span> : <span class="colorvalue">"Success"</span>
    }
          </code>
        </div>
</div>




  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    url: process.env.APImanage + '/api/v1/getprofile'
  }),
  methods: {
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    /*display: block;*/
    display: inline !important;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}

.codeExampleUrl {
  top: -2px;
  display: inline-block;
  padding: 4px 6px;
  border: 1px solid #24446e;
  font-size: 0.9rem;
  font-weight: bold;
  line-height: 1em;
  border-radius: 4px;
  background-color: #25446e52;
  color: #395171fa;
}
</style>


// WEBPACK FOOTER //
// src/components/home/api/docsbottommenu/getprofile.vue